import { render, staticRenderFns } from "./customersDeposit.vue?vue&type=template&id=793e7f7c&"
import script from "./customersDeposit.vue?vue&type=script&lang=js&"
export * from "./customersDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports